/**
 * region for libraries*/
import React, { Component } from "react";

/**
 * region for component*/
import { CategoriesDistributionChart } from "./CategoriesDistributionChart";
import { StaffContributionChart } from "./StaffContributionChart";
import { TotalKeywordChart } from "./TotalKeywordChart";
import { UnrelatedKeywordChart } from "./UnrelatedKeywordChart";
import { TitlesWithNoKeywordsLogChart } from "./TitlesWithNoKeywordsLogChart";
import { KeywordsDistributionChart } from "./KeywordsDistributionChart";

export class Dashboard extends Component {
  static displayName = Dashboard.name;

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="margin-container">
        <div className="ml-2 mr-2">
          <div className="container-fluid">
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
              <h3 className="mt-4">Keyword Index Dashboard</h3>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <StaffContributionChart />
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <TotalKeywordChart />
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <UnrelatedKeywordChart />
              </div>
              {/* </div>
            <div className="row mb-3"> */}
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <CategoriesDistributionChart />
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <TitlesWithNoKeywordsLogChart />
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <KeywordsDistributionChart />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
